<template>
  <div>
    <div class="panel panel-primary">
      <div class="panel-heading padding-0">
        <h3 class="text-center panel-title">
          <a :href="`#content${title.replace(' ', '')}`" data-toggle="collapse" class="collapsable-link-panel collapsable-link-panel-child">
            {{title}}
          </a>
        </h3>
      </div>
      <div :id="`content${title.replace(' ', '')}`" class="collapse">
        <div class="panel-body message-table-container collapse">
          <div class="row">
            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <treeselect :placeholder="`Add ${title}`" 
                :multiple="true" 
                :ref="`treeselect-${title}`"
                :options="optionList" 
                v-model="selectedOptions"
                search-nested
                @select="handleTreeSelect"  
                @deselect="handleTreeDeSelect"/>
              <div  v-if="showSingleLeafValidation" class="text-red" ref="errorDiv">{{ singleLeafValidationError }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'collapsible-multi-select',
  props: ['title', 'propOptions', 'optionList', 'singleLeafNodeCheck', 'singleLeafValidationError'],
  data () {
    return {
      parentNodesSelected: new Set(),
      showSingleLeafValidation: false,
      selectedOptions: []
    }
  },
  methods: {
    handleTreeSelect ({ id }) {
      if (this.singleLeafNodeCheck) {
        const treeselect = this.$refs[`treeselect-${this.title}`]
        const node = treeselect.getNode(id)
        let newValue

        if (node.isLeaf) {
          const { parentNode } = node
          if (this.parentNodesSelected.has(parentNode.id)) {
            treeselect.closeMenu()
            this.showSingleLeafValidation = true
            newValue = this.selectedOptions
            setTimeout(() => {
              this.selectedOptions = newValue
            })
          } else {
            this.showSingleLeafValidation = false
            this.parentNodesSelected.add(parentNode.id)
          }
        } else {
          if (node.children.length > 1) {
            treeselect.closeMenu()
            this.showSingleLeafValidation = true
            newValue = this.selectedOptions
            setTimeout(() => {
              this.selectedOptions = newValue
            })
          } else {
            this.showSingleLeafValidation = false
            this.parentNodesSelected.add(id)
          }
        }
      }
    },
    handleTreeDeSelect ({ id }) {
      if (this.singleLeafNodeCheck) {
        const treeselect = this.$refs[`treeselect-${this.title}`]
        const node = treeselect.getNode(id)

        if (node.isLeaf) {
          const { parentNode } = node
          if (this.parentNodesSelected.has(parentNode.id)) {
            this.parentNodesSelected.delete(parentNode.id)
          }
        } else {
          this.parentNodesSelected.delete(id)
        }
        this.showSingleLeafValidation = false
      }
    },
    getCustomLabel (node) {
      console.log(node)
      switch (this.title) {
        case 'Funnel Stages': return `${node.country} - ${node.funnel_name} - ${node.label}`
        case 'Snomed Codes': return `${node.legacy_name}`
        default: return node.label
      }
    },
    getData () {
      const selectedIds = this.selectedOptions.map(ele => {
        if (typeof (ele) === 'string') {
          if (ele.split('-').length > 1) {
            return ele.split('-')[1].trim()
          } else {
            return ele
          }
        } else {
          return ele
        }
      })
      return selectedIds
    },
    populateParentNodes (value) {
      for (let child of value) {
        for (let parent of this.optionList) {
          parent.children.forEach(ele => {
            if (ele.id === child) this.parentNodesSelected.add(parent.id)
          })
        }
      }
    },
    parseOptions (value) {
      this.selectedOptions = [...value]
    }
  },
  watch: {
    propOptions: function (value) {
      this.parseOptions(value)
      if (this.title === 'Funnel Stages' && this.singleLeafNodeCheck) {
        this.populateParentNodes(value)
      }
    }
  }
}
</script>
<style scoped>
  .secondary-color {
    color: '#FF1C77'
  }
  .multiline
  {
    white-space: pre-wrap;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
  }
  .messageset-table  td {
    -ms-word-break: break-all;
      word-break: break-all;
      word-break: break-word;
      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
      hyphens: auto;
  }
  .message-table-container {
    display: flex;
    flex-direction: column;
  }
  .message-properties {
    white-space: none;
    font-weight: bold;
    width: 100px;
    margin-bottom: 5px;
  }
  .message-edit-delete-btn-container {
    width: 110px;
    display: flex;
    border-bottom: none;
  }
  .margin-10 {
    margin: 10px;
  }
  .edit-delete-msg-btn-container {
    display: flex;
    width: 80px;
    border-bottom: none;
    border-top: 1px solid #e8e8e8;
    justify-content: space-around;
  }
  .panel-primary > .panel-heading {
    border-color: #0D9488
  }
  .panel-primary {
    border-color: #0D9488
  }
</style>



// WEBPACK FOOTER //
// collapsibleMultiSelect.vue?482feb78